module.exports = __webpack_public_path__ + "static/media/footerIcon-1.bcb01aeb.svg";